import { Box } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Stepper from '@/components/Stepper'
import NewKonvaCanvas from '@/components/canvas/NewKonvaCanvas'
import ImageEdit from '@/components/imageEdit/ImageEdit'
import { useAppSelector } from '@/hooks/redux'
import { useCanvasSize } from '@/hooks/useCanvasSize'
import CaseInfoLayout from '@/layout/CaseInfoLayout'
import { setSelectedPickerKey, updateAllInOneFormValue } from '@/store/allInOne'
import {
  ImageCalibrationStatus,
  setImageCalibrationStatus,
} from '@/store/sessionSlice'
import { getDehazedImageUrl } from '@/utils/helper'

import AllInOnePanel from './panel/AllInOnePanel'
import { ALL_IN_ONE_STEPS } from './utils/constants'

const AllInOne = () => {
  const dispatch = useDispatch()
  const canvasImage = useAppSelector((state) => state.app.canvasImage)
  const selectedPickerKey = useAppSelector(
    (state) => state.allInOne.selectedPickerKey,
  )

  const { containerRef, dimensions } = useCanvasSize()
  const recipeActiveStep = useAppSelector(
    (state) => state.allInOne.recipeActiveStep,
  )

  const selectedColor = useAppSelector((store) => store.app.selectedColor)

  const imageCalibrationStatus = useAppSelector(
    (state) => state.session.imageCalibrationStatus,
  )
  const onImageClick = () => {
    if (selectedPickerKey) {
      dispatch(
        updateAllInOneFormValue({
          name: selectedPickerKey,
          value: [selectedColor.L, selectedColor.a, selectedColor.b],
        }),
      )
      dispatch(setSelectedPickerKey(''))
    }

    if (
      imageCalibrationStatus?.[canvasImage?.id] ===
      ImageCalibrationStatus.CALIBRATING
    ) {
      dispatch(
        setImageCalibrationStatus({
          id: canvasImage?.id,
          status: ImageCalibrationStatus.CALIBRATED,
        }),
      )
    }
  }

  const path = useLocation().pathname
  const imageEdit = useAppSelector(
    (state) => state.app.imageEdit[path] || false,
  )

  return (
    <CaseInfoLayout rightPanel={<AllInOnePanel containerRef={containerRef} />}>
      <Box display="flex" flexDirection="column" flexGrow={1}>
        <Box>
          <Stepper steps={ALL_IN_ONE_STEPS} activeStep={recipeActiveStep} />
        </Box>
        <Box ref={containerRef} display="flex" flexGrow={1}>
          {!imageEdit ? (
            <>
              <NewKonvaCanvas
                type={canvasImage?.type}
                imageUrl={
                  getDehazedImageUrl(canvasImage) ||
                  canvasImage?.latest_image ||
                  canvasImage?.calibrated_image ||
                  canvasImage?.image
                }
                width={dimensions.width}
                height={dimensions.height}
                onImageClick={onImageClick}
                imageId={canvasImage?.id}
                rawWidth={canvasImage?.raw_width}
                rawHeight={canvasImage?.raw_height}
                isActiveCircle={!!selectedPickerKey}
              />
            </>
          ) : (
            <Box width={dimensions.width} height={dimensions.height}>
              <ImageEdit selectedImage={canvasImage} />
            </Box>
          )}
        </Box>
      </Box>
    </CaseInfoLayout>
  )
}

export default AllInOne
